import React from 'react';
import { Box } from '../core';
import { UpdateButton } from '../Graph/UpdateButton';
import { Legends, ILegend } from './Legends';
import { LoadingOverlay } from '../Graph/LoadingOverlay';
import { BoxProps } from 'theme-ui';

interface GraphProps extends BoxProps {
  chartId: string;
  loading: boolean;
  update?: any;
  outdated?: boolean;
  legends?: ILegend[];
}

export const Graph = ({
  chartId,
  loading,
  outdated,
  update,
  legends,
  sx = {},
  ...rest
}: GraphProps): JSX.Element => (
  <Box sx={{ height: '50vh', position: 'relative', ...sx }} {...rest}>
    <Legends legends={legends} />
    <UpdateButton
      onClick={() => update()}
      disabled={loading || !outdated}
      visible={update != null && outdated === true}
    />
    <LoadingOverlay loading={loading} />
    <Box sx={{ height: '50vh' }} id={chartId} />
  </Box>
);
